module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bloco-texto clearfix"
  }, [_c('figure', {
    staticClass: "imagem"
  }, [_c('img', {
    attrs: {
      "href": "#",
      "src": _vm.imagem
    }
  })]), _c('div', {
    staticClass: "texto"
  }, [_c('titulo', {
    staticClass: "-withbar"
  }, [_vm._t("titulo", [_vm._v(_vm._s(_vm.titulo))])], 2), _c('p', {
    staticClass: "paragrafo"
  }, [_vm._t("texto", [_vm._v(_vm._s(_vm.texto))])], 2), _c('router-link', {
    staticClass: "more",
    attrs: {
      "to": {
        name: 'Institucional',
        params: {
          slug: _vm.rota
        }
      }
    }
  }, [_c('small', [_vm._v("Ver tudo")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-779b1779","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/BlocoTexto.vue
// module id = 504
// module chunks = 0